function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent, Fragment } from "react";
import { commonInputStyles } from "../common-inputs.scss";
import { withGenericConfig } from "/contexts/generic-config-context";
import classnames from "classnames";
class TextInput extends PureComponent {
    render() {
        const { inputData, errorState, invalid, errorLabelId, id, defaultValue, translate } = this.props;
        const { inputName, type, isRequired, placeholder } = inputData;
        const { isValid } = errorState;
        const showRequiredError = !isValid && isRequired;
        const requiredClass = {
            "input-required": showRequiredError
        };
        const translatedPlaceholder = translate(placeholder);
        return /*#__PURE__*/ _jsxs(Fragment, {
            children: [
                /*#__PURE__*/ _jsx("input", {
                    id: id,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    name: inputName,
                    type: type,
                    placeholder: translatedPlaceholder,
                    "aria-required": isRequired,
                    "aria-invalid": invalid,
                    "aria-describedby": errorLabelId,
                    defaultValue: defaultValue,
                    className: `jsx-${commonInputStyles.__hash}` + " " + (classnames("hp-input hp-text-input", requiredClass) || "")
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: commonInputStyles.__hash,
                    children: commonInputStyles
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "handleBlur", (e)=>{
            const { onInputBlur } = this.props;
            if (onInputBlur) {
                onInputBlur(e);
            }
        });
        _define_property(this, "handleChange", (e)=>{
            const { onInputChange } = this.props;
            if (onInputChange) {
                onInputChange(e);
            }
        });
    }
}
TextInput.defaultProps = {
    invalid: false,
    errorLabelId: null
};
export default withGenericConfig(TextInput);
